import { render, staticRenderFns } from "./KPI.vue?vue&type=template&id=34306680&"
import script from "./KPI.vue?vue&type=script&lang=js&"
export * from "./KPI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports